import React from "react";

const FooterAbout = () => {
  return (
    <div>
      <div className=" ">
        <h2
          className="blog text-3xl text-center mt-6  font-bold poppins-b sm:text-4xl"
          style={{ color: "#453364" }}
        >
          HealthCare at Home Bangladesh
        </h2>
        <h2
          className=" blog text-3xl text-center  mt-6 font-bold poppins-b sm:text-4xl"
          style={{ color: "#453364" }}
        >
          ABOUT US
        </h2>
        <h1
          className="  w-32 h-1 rounded-lg mt-2 mb-4 mx-auto"
          style={{ backgroundColor: "#453364" }}
        ></h1>
        <div className="grid grid-cols-1 mx-10 px-10">
          <h2
            className="blog  text-justify mt-6 text-2xl    "
            style={{ color: "#453364" }}
          >
            HealthCare At Home Bangladesh, originated in 2019, has pioneered the
            services of providing health care at home in Bangladesh. Services
            include Physiotherapy, Nursing, Medical Assistants & Medical
            Caregivers, Babysitters, Emergency Medical & Transportation.
          </h2>

          <h2
            className=" blog text-3xl text-center  mt-6 font-bold poppins-b sm:text-4xl"
            style={{ color: "#453364" }}
          >
            Why HCAHBD?
          </h2>
          <h1
            className="  w-32 h-1 rounded-lg mt-2 mb-4 mx-auto"
            style={{ backgroundColor: "#453364" }}
          ></h1>
          <h2
            className="blog text-justify mt-6 text-2xl     "
            style={{ color: "#453364" }}
          >
            Home Health Care services were highly beneficial during the Covid-19
            Epidemic and since has grown into one of the fastest growing market
            in the health industry of Bangladesh.
          </h2>
          <h2
            className=" blog text-3xl text-center  mt-6 font-bold poppins-b sm:text-4xl"
            style={{ color: "#453364" }}
          >
            Advantages to HCAHBD
          </h2>
          <h1
          className="  w-32 h-1 rounded-lg mt-2 mb-4 mx-auto"
          style={{ backgroundColor: "#453364" }}
        ></h1>
          <h2
            className="blog text-justify   py-6 text-2xl     "
            style={{ color: "#453364" }}
          >
            There are a wide variety of benefits in availing health services at home.
          </h2>

        </div>
      </div>
    </div>
  );
};

export default FooterAbout;
